import { Component, Input } from '@angular/core';
import { MessageService } from 'primeng/api';
import { MerchantUserService } from 'app/services';

@Component({
    selector: 'partner-delete-employee',
    templateUrl: './partner-delete-employee.component.html',
    styleUrls: ['./partner-delete-employee.component.scss',
        '../../../../../styles/style-layout.scss']
})
export class PartnerDeleteEmployeeComponent {
    constructor(
        private messageService: MessageService,
        private merchantUserService: MerchantUserService) {
    }

    @Input()
    public showDeleteEmployee: boolean = false;

    @Input()
    public merchantUser: any = {};

    @Input()
    public onHide: () => void = () => { };
    public loading: boolean = false;

    public employeeIsDeleted: boolean = false;

    public deleteMerchantUser() {
        const dto = {
            MerchantUserId: this.merchantUser.UserId,
        };
        this.loading = true;
        this.merchantUserService.deleteMerchantUserById(dto, this.messageService)
            .then(data => {
                this.loading = false;

                if (!data) {
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.employeeIsDeleted = true;
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    public handleHideDeleteUserDialog() {
        this.onHide();
    }
}
